import { defineComponent } from 'vue';
import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;
import { MSConstant } from '@/commons/wildcards';
import store from '@/stores/store';
import { ModuleContext } from '@/stores/moduleConst';
import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';
import { showError } from '@/commons/globalMessage';
import { CustomPricingPartnerCodes } from '@/commons/constant';
import { ROLE } from '@/constants';

/**
 * Class chứa các function dùng chung cho hệ thống phía client
 */
class CommonFunction {
  getMainLoading() {
    let el = document.body.querySelector('#loading-cpn');
    return el;
  }
  mask() {
    let el = this.getMainLoading();
    if (el) {
      el.style.display = 'flex';
    }
  }
  unmask() {
    let el = this.getMainLoading();
    if (el) {
      el.style.display = 'none';
    }
  }
  infoLogging() {}
  errorLogging() {}
  handleException(error, showAlert) {
    console.error(error);

    if (showAlert) {
      const localize = i18n;
      showError(localize.t('i18nCommon.GlobalErrorMessage'));
    }
  }

  /**
   * Xử lý hiển thị dialog
   * @author DNThang - 30.10.2019
   * DNThang - 06.05.2020: Trong trường hợp owner là popup thì sẽ append vào content để không bị chìm ở dưới
   */
  prepareForDialog(component, owner, options) {
    if (owner && component) {
      var frmType = defineComponent({ extends: component }),
        frm = new frmType(options);

      frm.$mount();

      if (owner.isMsPopup) {
        let contentElement = owner.$refs.popupx; //owner.$el.querySelector('.ms-popup-content.ms-popup');
        contentElement.appendChild(frm.$el);
      } else {
        if (owner instanceof Element) {
          owner.appendChild(frm.$el);
        } else {
          owner.$el.appendChild(frm.$el);
        }
      }

      return frm;
    }

    return;
  }
  /**
   * Build vue key cho data
   */
  genVKeyValue(data, field = '__vKeyValue') {
    if (data) {
      data.forEach((item) => {
        item[field] = this.generateUUID();
      });
    }
  }
  /**
   *  Tạo uuid
   *  Create by: pvduong1 - 30/08/2019
   */
  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      let d = new Date().getTime();
      d += performance.now();
      let r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  /**
   * Guild empty
   */
  generateEmptyUUID() {
    return '00000000-0000-0000-0000-000000000000';
  }
  /**
   * Kiểm tra 2 đối tượng có phải là cha con của nhau không
   */
  hasParent(child, parent) {
    if (child.parentElement) {
      if (child.parentElement === parent) {
        return true;
      } else {
        return this.hasParent(child.parentElement, parent);
      }
    }

    return false;
  }

  /**
   * Kiểm tra đối tượng có class style không
   * Modified nntam: thêm case cối vào cho không chết
   */
  hasClass(element, className) {
    if (element && element.className) {
      return element.className.indexOf(className) > -1;
    }
    return false;
  }

  shortkeyPushView(el) {
    if (!window.shortkeyView) {
      window.shortkeyView = [];
    }
    window.shortkeyView.remove(el);
    window.shortkeyView.push(el);
  }

  shortkeyPopView(el) {
    window.shortkeyView.remove(el);
  }

  /**
   * Xử lý render element động
   * modified by ntphong 28/5/2021 - isAppendTarget: nếu là append 1 đoạn code html vào 1 trong target
   */
  renderDynamicElement(target, component, owner, options, isAppendTarget) {
    if (component) {
      var frmType = defineComponent({ extends: component }),
        frm = new frmType(options);

      frm.$mount();

      if (target && isAppendTarget && frm.$el) {
        target.appendChild(frm.$el);
      }
      return frm;
    }
  }

  /**
   * focus vào control tiếp theo
   */
  focusNextControl(curfocus) {
    var el = this.getNextInputControl(curfocus);
    if (el) {
      el.focus();
      if (typeof el.select === 'function') {
        el.select();
      }

      return true;
    }
  }

  /**
   * Kiểm tra element có hiển thị không
   */
  isVisible(element) {
    return element.offsetParent;
  }

  /*
   * Lấy control nhập liệu tiếp theo
   */
  getNextInputControl(current) {
    let me = this,
      //i = c.index(),
      p = current.parentNode;
    if (!p) {
      return null;
    }

    let ch = p.children,
      r = null,
      o,
      i = 0;
    for (; i < ch.length; i++) {
      if (ch[i] === current) {
        break;
      }
    }

    for (var k = i + 1; k < ch.length; k++) {
      o = ch[k];
      if (
        ['INPUT', 'TEXTARE', 'BUTTON', 'A'].indexOf(o.tagName) > -1 &&
        !o.getAttribute('disabled') &&
        !o.getAttribute('tabindex') !== -1 &&
        me.isVisible(o)
      ) {
        r = o;
      } else {
        r = me.getFirstControlFocus(o);
      }

      if (r) {
        break;
      }
    }

    if (!r) {
      r = me.getNextInputControl(p);
    }

    return r;
  }
  /**
   * Lấy control nhập liệu đầu tiên
   */
  getFirstControlFocus(parent) {
    const me = this,
      obj = parent || document,
      selector = [
        'input:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"]):not(.ms-con-dropdown)',
        'a:not([disabled]):not([tabindex="-1"]):not(.ms-collapse-item--header)',
      ].join(',');

    const items = obj.querySelectorAll(selector);
    if (items != null && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (me.isVisible(item)) {
          return item;
        }
      }
    }

    return null;
  }

  /**
   * Tìm ra control Input đầu tiên theo scope truyền vào và cho phép sửa
   * @param {Element} scope Parent cần tìm input
   */
  findFirstControlInput(scope) {
    if (scope && scope.querySelector) {
      var input = scope.querySelector(
        "input:not([type=button]):not([type=radio]):not([type=checkbox]):not([readonly]):not([disabled]):not([class='hidden']),textarea:not([readonly]):not([disabled]):not([class='hidden'])"
      );
      return input;
    }
    return;
  }

  /**
   * Tự động focus vào control nhập liệu đầu tiên theo scope truyền vào
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author DNThang - 31.10.2019
   */
  focusFirstControlInput(scope, select = true) {
    var me = this;

    // setTimeout(() => {
    var input = me.findFirstControlInput(scope);
    if (input) {
      input.focus();

      if (select && typeof input.select === 'function') {
        input.select();
      }
    } else {
      //nếu k có input nào để focus thì focus vào dòng đầu tiên của grid( nếu có ) để có thể thực hiện phím tắt keydown up/down để chọn dòng
      me.focusFirstRowGrid(scope);
    }
    // });
  }

  /**
   * Tự động focus vào control nhập liệu đầu tiên theo scope truyền vào
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author bnduc - 15.11.2019
   */
  focusFirstControl(scope) {
    if (scope) {
      const me = this;

      // setTimeout(() => {
      let input;
      if (
        scope.type === 'text' ||
        (scope.hasAttribute && scope.hasAttribute('type') && scope.getAttribute('type') === 'text')
      ) {
        input = scope;
      } else {
        input = me.findFirstControlFocus(scope);
      }

      if (input) {
        input.focus();
      }
      // });
    }
  }

  /**
   * Tự động focus vào control nhập liệu vào dòng đầu tiên của grid( nếu có ) để có thể thực hiện phím tắt keydown up/down để chọn dòng
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author nnlam - 16.06.2021
   */
  focusFirstRowGrid(scope) {
    if (scope) {
      const me = this;

      // setTimeout(() => {
      let grid;
      if (me.grid) {
        grid = me.grid.$el;
      } else {
        grid = me.findFirstGrid(scope);
      }

      if (grid) {
        //me.$nextTick(() => {
        if (grid) {
          let trFirst = grid.querySelector('.ms-tbody.data tr');
          if (trFirst) {
            trFirst.focus();
          }
        }
      }
    }
  }

  /**
   * Tìm ra control Input đầu tiên theo scope truyền vào và cho phép sửa
   * @param {Element} scope Parent cần tìm input
   * @author bnduc - 15.11.2019
   */
  findFirstControlFocus(scope) {
    if (scope && scope.querySelector) {
      let input = scope.querySelector('input:not([readonly]):not([disabled]),button:not([disable]),a,textarea');
      return input;
    }
    return;
  }

  /**
   * focus vào control trước đó
   */
  focusPreviewControl(curfocus) {
    const me = this;
    let fn = function (parent) {
      let items = parent.querySelectorAll('input:not([disabled]),button:not([disable]),a');
      if (items[0] !== curfocus) {
        for (let i = 1; i < items.length; i++) {
          if (items[i] === curfocus) {
            for (let j = i - 1; j >= 0; j--) {
              //check item visible
              if (me.isVisible(items[j])) {
                items[j].focus();
                return;
              }
            }
            //reset focus to parent
            curfocus = parent;
          }
        }
      }
      fn(parent.parentElement);
    };

    fn(curfocus.parentElement);
  }

  /**
   * Tìm ra grid đầu tiên của form
   * @param {Element} scope Parent cần tìm grid
   * @author nnlam - 16.06.2021
   */
  findFirstGrid(scope) {
    if (scope && scope.querySelector) {
      let grid = scope.querySelector('.ms-grid-viewer');
      return grid;
    }
    return;
  }

  /**
   * Xử lý khi focus control cuối cùng thì sẽ thực thi fn
   */
  processUnfocusLastControl(e, fn) {
    if (e.which === 9 && !e.shiftKey) {
      //console.log(e.target.attributes.class.value);
      let cur = e.target;
      let els = e.currentTarget.querySelectorAll('*');
      var flag = true;
      for (let i = 0; i < els.length; i++) {
        if (els[i] === cur) {
          flag = false;
          continue;
        }
        if (flag) {
          continue;
        }

        els[i].focus();
        if (els[i] === document.activeElement) {
          e.preventDefault();
          return;
        }
      }

      //focus first control
      e.preventDefault();
      fn();
    }
  }

  /**
   * Kiểm tra 2 đôi tượng có khác nhau không
   */
  checkDiff(newVal, oldVal) {
    let ret = false;
    let newStr = JSON.stringify(newVal).replace(/:null,/g, ":'',");
    let oldStr = JSON.stringify(oldVal).replace(/:null,/g, ":'',");
    return newStr !== oldStr;

    // if (typeof newVal == "object" && typeof oldVal == "object") {
    //   for (let field in newVal) {
    //     if (typeof newVal[field] != "object" && newVal[field] != oldVal[field]) {
    //       ret = true;
    //       break;
    //     }
    //   }
    // }
    // return ret;
  }
  /**
   * pvduy 28/06/2021
   * lẩy ra danh sách các trường thay đổi và giá trị thay đổi
   * thêm đoạn xử lý trường hợp tìm sự thay đổi cửa giá trị datetime
   */
  getDiffListProperty(newVal, oldVal) {
    let listField = [];
    if (typeof newVal == 'object' && typeof oldVal == 'object') {
      for (let field in newVal) {
        if (typeof newVal[field] != 'object' && newVal[field] != oldVal[field]) {
          listField.push(field);
        } else if (newVal[field] instanceof Date) {
          var isChange = false;
          // nếu 2 giá trị khác nhau hoặc một trong 2 thằng null thì xác nhận sự thay đổi.
          if (
            newVal[field] != null &&
            oldVal[field] != null &&
            typeof newVal[field].getTime == 'function' &&
            typeof oldVal[field].getTime == 'function' &&
            newVal[field].getTime() != oldVal[field].getTime()
          ) {
            isChange = true;
          } else if (
            (newVal[field] == null && oldVal[field] != null) ||
            (newVal[field] == null && oldVal[field] != null)
          ) {
            isChange = true;
          }
          if (isChange) {
            listField.push(field);
          }
        }
      }
    }
    return listField;
  }

  //Chuyển dữ liệu thành dạng tree
  // Created by LTDAT(16.06.2020)
  // Collap hết nếu số dòng quá lớn >200 : NCPHUOC 20/05/2020
  nomalizeDataTree(data, idField, parentField) {
    const me = this;
    let dataTemp = [...data],
      parentNodes = [];

    const cacheList = new Map();

    //Cache lại item trước để tăng performance
    dataTemp.forEach((item) => {
      item.childNodes = [];
      cacheList.set(item[idField], item);
      delete item.isParent;
    });
    // const collapseAll = data.length > MSConstant.DefaultMaxRecord.GridTree;
    dataTemp.forEach((item, index) => {
      if (item[parentField]) {
        //Tìm cha
        let parent = cacheList.get(item[parentField]);

        if (parent) {
          if (!parent.hasOwnProperty('isParent')) {
            parent['isParent'] = true;
          }
          parent.childNodes.push(item);
          //Cache lại parentNode luôn
          item.parentNode = parent;
          // if (collapseAll && item.level === 2) {
          //   item.isHide = true;
          // }
        } else {
          parentNodes.push(item);
        }
      } else {
        // NMSINH: thêm món này vì nếu chọn thằng ko có Cha trong list thì nó chính là cha luôn
        parentNodes.push(item);
      }
      item.expanded = true;

      // if (collapseAll && item.level === 2) {
      //   item.expanded = false;
      // } else {
      //
      // }
    });
    return parentNodes;
  }

  /**
   * Thực hiện ghép các node cha đi kèm với các node con luôn để thực hiện show ra ngay bên dưới node cha
   * @param {[TreeModel]} dataResoures Danh sách các node cha cần sắp xếp
   * @param {*} expanded Có Mở rộng ra không
   * @param {*} level
   */
  getBodyData(dataResoures, expanded, level = 1, childNodes = 'childNodes', isGroup = false) {
    if (!dataResoures) {
      return [];
    }
    let data = [...dataResoures];
    let bodyData = [];
    for (let i = 0; i < data.length; i++) {
      const row = data[i];
      const children = row[childNodes];
      const childrenLen = Object.prototype.toString.call(children).slice(8, -1) === 'Array' ? children.length : 0;

      row.level = level;
      // Vue.set(row, "isHide", false);
      // Vue.set(row, "expanded", expanded);
      // row.isHide = false;
      // row.expanded = expanded;

      row.isSelected = false;
      row._isSelectedMultiple = false;
      //Thêm caption group
      if (isGroup && row.caption) {
        row.caption += ` (${childrenLen})`;
      }
      bodyData.push(row);
      if (childrenLen > 0) {
        row._expandable = true;
        bodyData = bodyData.concat(this.getBodyData(children, expanded, level + 1, childNodes, isGroup));
      }
    }

    return bodyData;
  }

  /**
   * Sắp xếp dữ liệu cây để con đứng ngay sau cha
   * @param {*} orderField : Sắp xếp các con cùng cấp trước sau
   */
  sortTree(data, orderby, idField, parentIdField) {
    let sort = data.sortObject(orderby);

    let res = [];
    let parents = {};
    //đẩy root vào
    for (let i = 0; i < sort.length; i++) {
      let item = sort[i],
        parentId = item[parentIdField];
      if (parentId === null || parentId === undefined) {
        res.push(item);
      }

      parents[item[idField]] = item;
    }

    //duyệt đẩy con
    //do push vào con lần lượt vào ngay sau cha -> đảo ngược lại để đúng thứ tự
    sort.reverse();
    for (let i = 0; i < res.length; i++) {
      let processItem = res[i];

      for (let j = 0; j < sort.length; j++) {
        let item = sort[j];
        if (res.indexOf(item) > -1) {
          //đã duyệt
          continue;
        }

        if (item[parentIdField] === processItem[idField]) {
          let index = res.indexOf(processItem);
          //append vào vị trí sau cha
          res.splice(index + 1, 0, item);
        }
      }
    }

    //dí nốt các item chưa xử lý (có cha nhưng k tìm thấy cha)
    if (res.length < sort.length) {
      for (let j = 0; j < sort.length; j++) {
        let item = sort[j];
        if (res.indexOf(item) === -1) {
          res.push(item);
        }
      }
    }

    return res;
  }

  /**
   * Lấy giá trị enum theo text
   */
  getEnumValue(enumName, text) {
    let source = this.getEnumSource(enumName);
    let textTrim = text.trim();
    for (let i = 0; i < source.length; i++) {
      let item = source[i];
      if (textTrim === item.enumText) {
        return item.enumValue;
      }
    }

    return null;
  }

  /**
   * Lấy ra giá trị key của enum theo value
   * @param {Number} value Giá trị của enum cần lấy ra enum text
   * @param {String} enumName EnumName để get text
   */
  getEnumText(value, enumName) {
    //HTHIEP 14.03.2022: Fix tạm do thay đổi lại bộ enum, constant
    let e = MSConstant[enumName];

    if (e) {
      for (const key in e) {
        if (e.hasOwnProperty(key) && e[key] === value) {
          return key;
        }
      }
    }

    return value;
  }

  /**
   * Lấy ra resource theo enum
   * @param {Number} value Giá trị của enum cần lấy ra enum resource
   * @param {String} enumName EnumName để get text
   */
  getEnumResource(value, enumName) {
    const me = this,
      localize = i18n;

    let key = me.getEnumText(value, enumName);
    let resourceKey = enumName + '.' + key;
    let text = localize.t('i18nEnum.' + resourceKey);
    return text;
  }

  /**
   * Lấy enumsource với tên enum truyền vào
   * @param {String} enumName Tên enum trong enumeration
   * @param {Array} values Danh sách các enum lấy ra (nếu cần chỉ định), nếu không thì sẽ lấy tất cả
   * @param {Boolean} prefixIdx Có kèm theo tiền tố index không: true - có, false - không (Mặc định không)
   * VD: getEnumSource("EnumCABAReasonType",[10,11,12,13])
   * CreatedBy: PDKIEN 15/08/2019
   */
  getEnumSource(enumName, values, prefixIdx) {
    let e = MSConstant[enumName],
      arr = [];
    if (e) {
      let idx = 0;
      for (const key in e) {
        if (e.hasOwnProperty(key)) {
          let v = e[key],
            ix = -1;
          if (!values || (ix = values.indexOf(v)) > -1) {
            /*
             * sửa lại cách lấy dữ liệu theo enum
             * pvduy 02/02/2020
             */
            let enumText = i18n.t('i18nEnum.' + enumName + '.' + key);
            if (prefixIdx) {
              enumText = ++idx + '. ' + enumText;
            }

            let item = {
              enumValue: v,
              enumKey: key,
              enumText: enumText,
            };

            if (ix > -1) {
              // DVQUAN: sửa lại cách lấy enum source với trường hợp 9 và 99 => không lấy được 1 trong 2
              if (arr[ix]) {
                arr[arr.length] = item;
              } else {
                arr[ix] = item;
              }
            } else {
              arr.push(item);
            }
          }
        }
      }
    }
    return arr;
  }

  /**
   * Lấy tham số trên query string
   */
  getUrlParams() {
    let search;
    if (window.location.hash) {
      search = window.location.hash.substr(1);
    } else {
      search = window.location.search;
    }
    const temp = new URLSearchParams(search);
    let result = {};
    for (var value of temp.keys()) {
      result[value] = temp.get(value);
    }

    return result;
  }

  /**
   * Đăng xuất khỏi ứng dụng
   */
  logoff() {
    //giải phóng tài nguyên
    let storeDebug = store;
    let fn = [ModuleContext, 'logoff'].join('/');
    store.dispatch(fn);
    window.location.href = '/';
  }

  downloadLink(link) {
    // location.href = link;
    let a = document.getElementById('adownload');
    a.href = link;
    a.click();
  }

  /**
   * Gán cookie
   */
  setCookie(name, value, seconds) {
    var expires = '';
    if (seconds) {
      var date = new Date();
      date.setTime(date.getTime() + seconds * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  /**
   * Đọc cookie
   */
  getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * Xóa cookie
   */
  removeCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  /**
   * Xử lý dữ liệu trả về từ server
   */
  processServerResponseData(data) {
    if (data) {
      const rgDate = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d$/;
      const rgDateTime = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(.)?(\d{0,9})?(Z)?(\+)?(\d{2})?(:)?(\d{2})?$/;
      for (let i in data) {
        if (data[i]) {
          if (
            typeof data[i] === 'string' &&
            // i.indexOf("Date") > -1 &&
            (rgDate.test(data[i]) || rgDateTime.test(data[i]))
          ) {
            data[i] = new Date(data[i]);
          } else if (typeof data[i] === 'object' && Object.keys(data[i].length > 0)) {
            this.processServerResponseData(data[i]);
          }
        }
      }
    }
  }

  /**
   * Lấy text hiển thị của trường thông tin
   * @param {*} field : Tên trường
   * @param {*} namespace : mã để xem có custom lại không, nếu không thì lấy mặc định
   */
  getColumnText(field, namespace) {
    const localize = i18n;
    const common = localize.messages[localize.locale]['i18nColumn'];
    const custom = namespace ? common[namespace] : null;

    if (custom && custom.hasOwnProperty(field)) {
      return custom[field];
    }
    return common[field];
  }

  /**
   * Lấy text hiển thị của bảng
   * @param {*} table : Tên bảng
   * @param {*} namespace : mã để xem có custom lại không, nếu không thì lấy mặc định
   */
  getTableText(table, namespace) {
    const localize = i18n,
      common = localize.messages[localize.locale]['i18nTable'],
      custom = namespace ? common[namespace] : null;

    if (custom && custom.hasOwnProperty(table)) {
      return custom[table];
    }
    return common[table];
  }
  /**
   * Maping từ html element thành đối tượng vuejs để thao tác
   * @param {object} dom html dome element
   */
  mapDomToVue(dom) {
    return dom.__vue__;
  }

  /**
   * Chuyển tiếng việt có dấu thành không dấu
   * @author ĐVThi 09/03/2021
   */
  removeVietnameseTones(str) {
    if (str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
      str = str.replace(/đ/g, 'd');
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
      str = str.replace(/Đ/g, 'D');
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, ' ');
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      //str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
      return str;
    } else {
      return '';
    }
  }

  buildFilterParam(filters) {
    let me = this,
      sFilter = '';

    if (filters && !(filters instanceof Array)) {
      filters = [filters];
    }

    let length = filters.length;

    if (length > 0) {
      let i,
        arrayFilters = [],
        sJoin = ',';

      for (i = 0; i < length; i++) {
        let filter = filters[i],
          sChildFilter = '',
          operandChild = 'and';

        if (filter.childrens instanceof Array && filter.childrens.length > 0) {
          let childFirst = filter.childrens[0];
          if (childFirst.operand) {
            operandChild = childFirst.operand;
          }

          sChildFilter = me.buildFilterParam(filter.childrens);
        }

        let s = '"' + filter.property + '",' + (filter.operator ? '"' + filter.operator + '",' : ''),
          //Mặc định operand là `and`
          operand = '"and"';

        s += me.nomalizeFilterValue(filter.operator, filter.value);
        //xử lý tình huống muôn filter = 0/false nhưng muốn lọc ra cả các giá trị null
        if (filter.nullToFail && (filter.value === 0 || filter.value === false)) {
          s += ',true';
        }

        s = '[' + s + ']';

        if (sChildFilter) {
          s = '[' + s + ',"' + operandChild + '",' + sChildFilter + ']';
        }

        if (i !== 0) {
          if (filter.operand) {
            operand = '"' + filter.operand + '"';
          }
          arrayFilters.add(operand);
        }
        arrayFilters.add(s);
      }

      sFilter = arrayFilters.join(sJoin);
      if (length > 1) {
        sFilter = '[' + sFilter + ']';
      }
    }

    return sFilter;
  }

  nomalizeFilterValue(operator, value) {
    var ret = '';
    switch (operator) {
      case 'in':
      case 'notin':
        ret = JSON.stringify(value);
        break;
      default:
        if (typeof value === 'number') {
          ret = value.toString();
        } else if (typeof value === 'boolean') {
          ret = value;
        } else if (value instanceof Date) {
          if (value.getHours() === 0 && value.getMinutes() === 0 && value.getSeconds() === 0) {
            ret = ['"', moment(value).format('YYYY-MM-DD'), 'T00:00:00"'].join('');
          } else {
            ret = ['"', moment(value).format('YYYY-MM-DDThh:mm:ss'), '"'].join('');
          }
        } else {
          ret = ['"', value, '"'].join('');
        }
    }

    return ret;
  }

  /**
   * Xử lý tham số trước khi gọi lên server load dữ liệu cho combobox
   */
  processComboboxParamRequest(param) {
    const me = this;
    for (let i in param) {
      let value = param[i];
      switch (i) {
        case 'filter':
          //chuẩn hóa tham số filter
          if (Array.isArray(value) && value.length > 0) {
            value = me.buildFilterParam(value);
          } else {
            continue;
          }
          break;
      }
      param[i] = value;
    }
  }

  setLocalStorage(key, value) {
    localStorage.setItem(this.processLocalStorageKey(key), value);
  }

  getLocalStorage(key) {
    return localStorage.getItem(this.processLocalStorageKey(key));
  }

  removeLocalStorage(key) {
    localStorage.removeItem(this.processLocalStorageKey(key));
  }

  processLocalStorageKey(key) {
    return [window._appConfig.localStoragePrefix, key].join('');
  }

  setSessionStorage(key, value) {
    sessionStorage.setItem(key, value);
  }

  getSessionStorage(key) {
    return sessionStorage.getItem(key);
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  checkFullMonth(fromDate, toDate) {
    let shortText = '',
      localize = i18n;
    if (fromDate && toDate) {
      if (fromDate.getDate() == 1) {
        let fromYear = fromDate.getFullYear(),
          fromMonth = fromDate.getMonth();
        let toYear = toDate.getFullYear(),
          toMonth = toDate.getMonth();
        let daysOfMonth = 32 - new Date(toYear, toMonth, 32).getDate();
        if (toDate && daysOfMonth == toDate.getDate()) {
          if (fromMonth == toMonth && fromYear == toYear) {
            shortText = localize.t('i18nReport.ReportTerm').format(fromMonth + 1, fromYear);
          } else if (fromMonth < toMonth && fromYear == toYear) {
            shortText = localize.t('i18nReport.ReportTermRange').format(fromMonth + 1, toMonth + 1, fromYear);
          }
          return shortText;
        }
      }
    }
    return shortText;
  }

  helpAms(helpId) {
    return [window._external.amisAmsHelp, helpId].join('');
  }

  /**
   * Func bỏ dấu tiếng việt
   * @param {String} str
   * @author NCThanh1
   */
  removeUnicode(str) {
    let tmp = str;
    tmp = tmp.toLowerCase();
    tmp = tmp.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    tmp = tmp.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    tmp = tmp.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    tmp = tmp.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    tmp = tmp.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    tmp = tmp.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    tmp = tmp.replace(/đ/g, 'd');
    tmp = tmp.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, ' ');
    tmp = tmp.replace(/ + /g, ' ');
    tmp = tmp.trim();
    return tmp;
  }

  /**
   * Load dữ liệu combobox
   */
  getCacheComboboxData(type, payload, loadPromise, loadScope) {
    let key = [type, JSON.stringify(payload)].join('_').toLowerCase(),
      cache = window._cboData[key];

    return new Promise((resolve) => {
      if (cache) {
        resolve(cache);
        return;
      }

      loadPromise.call(loadScope, payload).then((result) => {
        window._cboData[key] = result;
        resolve(result);
      });
    });
  }

  /**
   * Load dữ liệu combobox
   */
  removeCacheComboboxData(key) {
    const caches = window._cboData;
    if (caches) {
      var keys = [];
      if (Array.isArray(key)) {
        keys = key;
      } else if (typeof key === 'string') {
        keys.push(key);
      } else {
        keys.push(String(key));
      }

      keys.forEach((item) => {
        let key = [item, ''].join('_').toLowerCase(),
          removeKeys = [];
        for (let i in caches) {
          if (i.indexOf(key) === 0) {
            removeKeys.push(i);
          }
        }

        for (let i = 0; i < removeKeys.length; i++) {
          let cacheKey = removeKeys[i];
          delete caches[cacheKey];
        }
      });
    }
  }

  /**
   * Tách từ khóa tìm kiếm thành các từ theo quy tắc
   * 1. Nếu có ngoặc kép "" thì tìm đúng kí tự trong ngoặc kép
   * 2. Nếu không thì chỉ cần chứa cả 2 kí tự là đủ
   * @param {string} keyword từ khóa tìm kiếm
   * @author NVLAM 23.11.2020
   */
  splitKeyWord(keyword) {
    let wordArr = [];
    if (typeof keyword !== 'string') {
      keyword = _.toString(keyword);
    }
    let firstDoubleQuoteIdx = keyword.indexOf('"'),
      lastDoubleQuoteIdx = keyword.lastIndexOf('"');
    /**
     * Các TH tìm kiếm full text
     * 1. Đây là foo
     * 2. "Đây là foo
     * 3. Đây "là foo"
     * 4. "Đây là" foo
     */
    if (
      firstDoubleQuoteIdx === -1 ||
      firstDoubleQuoteIdx === lastDoubleQuoteIdx ||
      firstDoubleQuoteIdx !== 0 ||
      lastDoubleQuoteIdx !== keyword.length - 1
    ) {
      wordArr = keyword.split(/\s+/); //tách theo dấu cách
    } else {
      let fullText = keyword.slice(firstDoubleQuoteIdx + 1, lastDoubleQuoteIdx);
      if (!_.isEmpty(fullText)) {
        wordArr.push(fullText);
      }
    }
    // for (let i = 0; i < wordArr.length; ++i) {
    //     wordArr[i] = wordArr[i].replace(/[^a-z\d]/g, '\\$&');//chèn thêm 1 kí từ
    // }
    return wordArr;
  }

  /**
   * hàm search local
   * properties: danh sách các trường cần search
   * searchText: text nhập ở ô search
   * source: dữ liệu gốc dùng để filter
   * grid: grid filter
   */
  filterFn(properties, source, grid, searchText, form) {
    let data = [],
      me = this;
    let sourceTemp = [];
    if (Array.isArray(source)) {
      Object.assign(sourceTemp, source);
      if (searchText && searchText != '') {
        sourceTemp.forEach((item) => {
          if (
            me.checkSearchText(item, properties, searchText) &&
            me.checkFilterHeader(item, grid) &&
            form.checkFilterGridTreeCustom(item, properties, searchText)
          ) {
            if (data.indexOf(item) === -1) {
              data.push(item);
            }
            if (grid && grid.isGridTree) {
              me.findParentNode(source, data, item, form);
            }
          }
        });
      } else {
        data = sourceTemp;
      }
    }
    if (form.filterHeader && form.filterHeader.length > 0) {
      grid.dataTemp = data;
    } else {
      grid.dataTemp = source;
    }
    return data;
  }

  /*
   *  Hàm tìm kiếm các node cha khi thực hiện tìm kiếm dữ liệu.
   *  pvduy 06/01/2021
   */
  findParentNode(items, filterItems, itemChild, form) {
    let me = this;
    let key = '',
      parentKey = 'ParentID';
    if (form && form.grid && form.grid.idProperty) {
      key = form.grid.idProperty;
    }
    if (form && form.grid && form.grid.parentIdProperty) {
      parentKey = form.grid.parentIdProperty;
    }
    items.forEach((item) => {
      if (item[key] == itemChild[parentKey] && !filterItems.find((x) => x[key] == item[key])) {
        if (filterItems.indexOf(item) === -1) {
          filterItems.push(item);
        }
        me.findParentNode(items, filterItems, item, form);
      }
    });
  }
  /**
   * hàm filter col
   */
  checkFilterHeader(item, grid) {
    let listFilterHeader = [],
      check = true;
    listFilterHeader = grid.getFilterHeader(true);
    if (listFilterHeader.length > 0) {
      listFilterHeader.forEach((filter) => {
        let value = filter.value ? (filter.value + '').toLowerCase() : '';
        switch (filter.operator) {
          case MSConstant.FilterOperator.Contains:
            if (!(item[filter.property] ? item[filter.property].toLowerCase() : '').contains(value)) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.Notcontains:
            if ((item[filter.property] ? item[filter.property].toLowerCase() : '').contains(value)) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.StartsWith:
            if (!(item[filter.property] ? item[filter.property].toLowerCase() : '').startsWith(value)) {
              return false;
            }
            break;
          case MSConstant.FilterOperator.EndsWith:
            if (!(item[filter.property] ? item[filter.property].toLowerCase() : '').endswith(value)) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.Equals:
            if (item[filter.property] != filter.value) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.NotEquals:
            if (item[filter.property] == filter.value) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.GreaterThan:
            if (item[filter.property] <= filter.value) {
              check = false;
              return false;
            }
            break;
          // case MSConstant.FilterOperator.GreaterThan:
          //   if(item[filter.property] < filter.value){
          //     check = false;
          //     return false;
          //   }
          //   break;
          case MSConstant.FilterOperator.LessThan:
            if (item[filter.property] >= filter.value) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.LessThanEquals:
            if (item[filter.property] > filter.value) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.Between:
            //if(item[filter.property] > filter.value){
            check = false;
            return false;
            //}
            break;
          case MSConstant.FilterOperator.Null:
            if (item[filter.property]) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.NotNull:
            if (!item[filter.property]) {
              check = false;
              return false;
            }
            break;
        }
      });
    }
    return check;
  }
  /**
   * hàm search theo text
   */
  checkSearchText(item, properties, searchText) {
    let me = this,
      check = false;

    if (searchText) {
      let text = searchText.toLowerCase();
      if (Array.isArray(properties)) {
        properties.forEach((field) => {
          if (item[field] && item[field].toString().toLowerCase().contains(text)) {
            check = true;
            return;
          }
        });
      }
    } else {
      return true;
    }
    return check;
  }

  /**
   * Hàm search theo bộ lọc khác (vd theo dõi/ ngừng theo dõi,...)
   */
  checkFilterObject(item, filter) {
    let check = false;

    if (item && filter) {
      let props = Object.keys(filter);

      if (filter && props) {
        props.forEach((field) => {
          if (
            item[field] != null &&
            item[field] != undefined &&
            filter[field] != null &&
            filter[field] != undefined &&
            item[field].toString().toLowerCase().contains(filter[field].toString().toLowerCase())
          ) {
            check = true;
            return;
          }
        });
      } else {
        return true;
      }
    }
    return check;
  }

  /**
   * Lấy thông tin phiên đăng nhập
   */
  getContext() {
    const windowKey = '_context';
    let context = window[windowKey];
    if (!context) {
      context = this.getLocalStorage('Context');
      if (context) {
        window[windowKey] = context = JSON.parse(context);
      }
    }

    return context;
  }

  /**
   * xử lý string trước khi render để chống xss
   */
  processXssValue(value) {
    if (typeof value === 'string') {
      // return value.replace(/</g, '&lt');
      return _.escape(value);
    }

    return value;
  }

  /**
   * Xử lý nội dung dữ liệu trước khi binding để tránh tấn công xss
   */
  processXss(item) {
    const me = this;
    let fn = function (obj, lv) {
      lv = lv || 0;
      for (let i in obj) {
        let v = obj[i];
        if (v) {
          if (typeof v === 'string') {
            obj[i] = me.processXssValue(v);
          } else if (typeof v == 'object' && lv < 10 && Object.keys(v).length > 0) {
            fn(v, lv + 1);
          }
        }
      }
    };
    if (Array.isArray(item)) {
      item.forEach((n) => {
        fn(n);
      });
    } else if (typeof item === 'object') {
      fn(item);
    }
  }

  /**
   * Xử lý tham số date
   * Xử lý dữ liệu trước khi ném lên server
   * Xử lý để k dính lỗi múi giờ
   */
  processDateParam(param, isDateFn) {
    for (let i in param) {
      let value = param[i];

      if (value && isDateFn(value)) {
        param[i] = moment(value).format('YYYY-MM-DD');
      }
    }
  }

  /**
   * Lấy đường dẫn đầy đủ cho form link
   */
  getFullLink(formLink) {
    let url = [];
    if (location.pathname.toLocaleLowerCase().indexOf('/app/') === 0) {
      url.push('/app');
    }
    url.push(formLink);
    return url.join('');
  }

  /**
   * Lấy tên báo cáo
   */
  getReportName(reportId, defaultName) {
    const localize = i18n,
      key = 'i18nReport.name.' + reportId;

    let text = localize.t(key);
    return text === key ? defaultName || null : text;
  }

  /**
   * Xóa các phần tử trùng field trong mảng
   * @author: nnnam - 19/11/2020
   * @param {Array} arr Mảng cần distinct
   * @param {...string} args Trường key xác định distinct
   */
  distinct(arr = [], ...args) {
    let result = [];
    if (args.length) {
      result = arr.filter(function (value, index, self) {
        /** Kiểm tra index phần từ đầu tiên thỏa mãn có phải phần tửu hiện tại (không thì loại bỏ) */
        return (
          self.findIndex(function (x) {
            /** Lấy phần từ đầu tiên thỏa mãn */
            return args.every((field) => x[field] == value[field]);
          }) === index
        );
      });
    } else {
      /** Mảng chứa mapping sang json để so sánh */
      let arrJson = arr.map((x) => JSON.stringify(x));
      /** Loại bỏ các item giống nhau */
      arrJson = [...new Set(arrJson)];
      result = arrJson.map((x) => x && JSON.parse(x));
    }
    return result;
  }

  /**
   * Viết hoa chữ cái đầu
   * @author nnnam - 5/3/2021
   * @param {any} str
   */
  capitalize(str) {
    return str ? str[0].toUpperCase() + str.substring(1) : str;
  }

  /**
   * Đọc số thành chữ
   * @author nnnam - 5/3/2021
   * @param {number} num
   */
  sayNumber(num) {
    if (num) {
      let sayNumber = '';
      let maxLength = 15;
      let length = num.toString().length;
      let strNum = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín', 'mười'];

      /**
       * Đọc 1 nhóm số gồm 3 chữ số
       * @author nnnam - 5/3/2021
       * @param {string} grNum
       */
      let sayAGroupDigit = (grNum) => {
        let sayNums = [];
        if (grNum != '000') {
          let says = ['trăm', 'mươi', ''];
          let nums = grNum.split('').reverse();
          nums.length = 3;
          nums = nums.reverse().map((x) => parseInt(x));
          let sayGrNum = nums.map((x) => strNum[x]);

          let numHundred = nums[0];
          let numDozen = nums[1];
          let numUnit = nums[2];

          if (numHundred == 0 || numDozen != 0 || numUnit != 0) {
            if (numHundred != undefined) {
              sayNums.push(strNum[numHundred] + ' ' + says[0]);
            }

            if (numDozen != undefined) {
              switch (numDozen) {
                case 0:
                  sayNums.push('linh');
                  break;
                case 1:
                  sayNums.push('mười');
                  break;
                default:
                  sayNums.push(strNum[numDozen] + ' ' + says[1]);
                  break;
              }
            }

            if (numUnit) {
              if (numUnit == 1 && numDozen != 0 && numDozen != 1 && numDozen != undefined) {
                sayNums.push('mốt');
              } else {
                sayNums.push(strNum[numUnit]);
              }
            }
          } else {
            if (numHundred) {
              sayNums.push(strNum[numHundred] + ' ' + says[0]);
            }
          }
        }

        return sayNums.join(' ');
      };

      /**
       * Chia chuỗi số thành các nhóm 3 chữ số
       * @author nnnam - 5/3/2021
       * @param {string} value
       */
      let splitNumber = function group(value) {
        return value.match(/\d{1,3}(?=(\d{3})*$)/g);
      };

      let countGr = parseInt((length - 1) / 3);
      let grUnit = ['', 'nghìn', 'triệu', 'tỷ', 'nghìn tỷ'];
      let splitNum = splitNumber(num.toString()).map((x, i) => sayAGroupDigit(x) + ' ' + grUnit[countGr - i]);
      sayNumber = this.capitalize(splitNum.join(' ').trim());
      return sayNumber;
    } else {
      return 'Không';
    }
  }

  /**
   * Cách đọc số thứ tự
   * @author nnnam - 5/3/2021
   * @param {any} num
   */
  sayOrder(num) {
    if (num == 1) {
      return 'Nhất';
    } else {
      return this.sayNumber(num);
    }
  }

  /**
   * Format số
   * @param {number} num
   * @param {number} count
   */
  formatNumberToString(num, len) {
    let result = num.toString();
    let count = result.length;
    if (num != 0 && count < len) {
      result = '0'.repeat(len - count) + num;
    }
    return result;
  }

  /**
   * Tính toán theo phép tính
   * @author nnnam - 11/6/2021
   * @param {number} a
   * @param {number} b
   * @param {any} operation
   */
  calculateOperation(a, b, operation) {
    switch (operation) {
      case '+':
        return a + b;
      case '-':
        return a - b;
      case '*':
        return a * b;
      case '/':
        return a / b;
    }
  }

  /**
   * Group by theo key
   * @author nnnam - 2/6/2021
   * @param {Array} list
   * @param {any} key
   */
  groupBy(list, key) {
    return list.reduce((obj, item) => {
      obj[item[key]] = [...(obj[item[key]] || []), item];
      return obj;
    }, {});
  }

  /**
   * Tính tổng các số của các đối tượng trong mảng
   * @author nnnam - 2/6/2021
   * @param {Array} list Mảng
   * @param {Array} notNumberFields Các trường group
   */
  summary(list, notNumberFields) {
    list = list || [];
    let first = list[0];

    if (first) {
      /** Mặc định các trường group không phải number */
      notNumberFields = notNumberFields || Object.keys(first).filter((key) => typeof first[key] != 'number');
      /** Các trường summary không group
       *  @type Array */
      let numberFields = Object.keys(first).filter((key) => !notNumberFields.contains(key));
      /** Lưu json của key */
      let jsonObj = {};
      /** Lấy mảng chứa object key của mảng */
      let mapData = this.distinct(
        list.map((item, i) => {
          let obj = notNumberFields.reduce((o, key) => {
            o[key] = item[key];
            return o;
          }, {});
          let key = JSON.stringify(obj);
          jsonObj[key] = [...(jsonObj[key] || []), item];
          return obj;
        })
      );

      /** Tính tổng từng group */
      mapData.forEach((o) => {
        let dataGroup = jsonObj[JSON.stringify(o)];
        /** Tính tổng từng thuộc tính trong group */
        numberFields.forEach((field) => {
          o[field] = dataGroup.map((x) => x[field]).reduce((sum, x) => sum + x, 0);
        });
      });

      return mapData;
    } else {
      return [];
    }
  }

  /**
   * Group mảng theo key
   * @author nnnam - 14/6/2021
   * @param {Array} arr Mangr
   * @param {Function} fnKey Function key
   */
  getGroupByFuncKey(arr, fnKey) {
    return arr.reduce((obj, x) => {
      let key = JSON.stringify(fnKey(x));
      obj[key] = [...(obj[key] || []), x];
      return obj;
    }, {});
  }

  /**
   * Fill tất cả các property của các đối tượng trong mảng
   * @author nnnam - 14/6/2021
   * @param {Array} list Mảng
   */
  fillAllProperties(list) {
    /** Clone mảng */
    var result = _.cloneDeep(list);
    /** Tất cả property của object trong mảng */
    let keys = list.reduce((arr, x) => this.distinct(arr.concat(Object.keys(x))), []);
    /** Set các thuộc tính = null */
    list
      .filter((x) => Object.keys(x).length != keys.length)
      .forEach((obj) => {
        keys
          .filter((key) => !obj.hasOwnProperty(key))
          .forEach((key) => {
            obj[key] = null;
          });
      });

    return list;
  }

  /**
   * Join chung 2 mảng với nhau
   * @author nnnam - 14/6/2021
   * @param {Array} leftArr
   * @param {Array} rightArr
   * @param {Function} lKey
   * @param {Function} rKey
   * @param {Function} action
   * @param {Function} getKey
   */
  joinArray(leftArr, rightArr, lKey, rKey, action = (l, r) => $.extend({}, r, l), getKey) {
    /** Group 2 mảng */
    let left = this.getGroupByFuncKey(leftArr, lKey);
    let right = this.getGroupByFuncKey(rightArr, rKey);
    /** Lấy value key sau khi group */
    let keys = getKey ? getKey(left, right) : [];
    /** Join 2 bảng với nhau */
    let rs = keys.reduce((arr, key) => {
      let lVal = left[key] || [null];
      let rVal = right[key] || [null];
      /** Lấy kết quả trả về */
      lVal.forEach((l) => rVal.forEach((r) => arr.push(action(l, r))));
      return arr;
    }, []);

    let result = this.fillAllProperties(rs);
    return result;
  }

  /**
   * Fulljoin 2 mảng với nhau
   * @author nnnam - 14/6/2021
   * @param {Array} leftArr
   * @param {Array} rightArr
   * @param {Function} lKey
   * @param {Function} rKey
   * @param {Function} action
   */
  fullJoin(leftArr, rightArr, lKey, rKey, action = (l, r) => $.extend({}, r, l)) {
    /** Full join các key */
    return this.joinArray(leftArr, rightArr, lKey, rKey, action, (left, right) => {
      return this.distinct(Object.keys(left).concat(Object.keys(right)));
    });
  }

  /**
   * Join 2 mảng với nhau
   * @author nnnam - 14/6/2021
   * @param {Array} leftArr
   * @param {Array} rightArr
   * @param {Function} lKey
   * @param {Function} rKey
   * @param {any} action
   */
  innerJoin(leftArr, rightArr, lKey, rKey, action = (l, r) => $.extend({}, r, l)) {
    /**  Join các key trùng nhau */
    return this.joinArray(leftArr, rightArr, lKey, rKey, action, (left, right) => {
      return Object.keys(left).filter((element) => Object.keys(right).includes(element));
    });
  }

  /**
   * LeftJoin 2 mảng với nhau
   * @author nnnam - 14/6/2021
   * @param {Array} leftArr
   * @param {Array} rightArr
   * @param {Function} lKey
   * @param {Function} rKey
   * @param {any} action
   */
  leftJoin(leftArr, rightArr, lKey, rKey, action = (l, r) => $.extend({}, r, l)) {
    /** Lấy key bên trái */
    return this.joinArray(leftArr, rightArr, lKey, rKey, action, (left, right) => {
      return Object.keys(left);
    });
  }

  /**
   * RightJoin 2 mảng với nhau
   * @author nnnam - 14/6/2021
   * @param {Array} leftArr
   * @param {Array} rightArr
   * @param {Function} lKey
   * @param {Function} rKey
   * @param {any} action
   */
  rightJoin(leftArr, rightArr, lKey, rKey, action = (l, r) => $.extend({}, l, r)) {
    /** Lấy key bên phải */
    return this.joinArray(leftArr, rightArr, lKey, rKey, action, (left, right) => {
      return Object.keys(right);
    });
  }

  /**
   * Tính toán lại dữ liệu cây
   * @param {Array} data Dữ liệu
   * @param {string} idField Trường ID
   * @param {string} parentField Trường Id cha
   * @param {Array} numberFields Danh sách trường cần cộng
   * @author nnnam - 25/4/2022
   */
  refreshCalculateTree(data, idField, parentField, numberFields) {
    if (data.length) {
      if (!numberFields || !numberFields.length) {
        numberFields = Object.keys(data[0]).filter((x) => x.includes('Amount'));
      }

      let func = (node) => {
        let childs = data.filter((x) => x[parentField] == node[idField]);
        childs.forEach(func);
        childs.length &&
          numberFields.forEach((field) => {
            node[field] = childs.reduce((sum, x) => sum + x[field], 0);
          });
      };

      data.filter((x) => !x[parentField]).forEach(func);
    }
  }

  /**
   * Build config table
   * @param {Array} rows
   * @author nnnam - 28/4/2022
   */
  getConfigHeader(rows) {
    /** Số dòng */
    let len = rows.length;
    /** Đệ quy */
    let rs = rows[0].reduce(
      (obj, col) => {
        /**
         * Hàm đệ quy build config
         * @param {any} col Config cột
         * @param {any} iRow Thứ tự dòng
         * @param {any} rSpan Total rowspan
         * @param {any} skip Có bỏ qua các dòng sau không?
         */
        let func = (col, iRow, rSpan, skip) => {
          let colspan = col.colspan || 1;
          let rowspan = col.rowspan || 1;
          /** Độ dài Rowspan */
          let lenRowspan = rSpan + rowspan;

          /** Tăng thứ tự stack */
          obj.Childs[iRow] = (obj.Childs[iRow] || 0) + 1;

          /** Kiểm tra điều kiện build */
          skip = !skip && colspan == 1 && (col.field || rowspan == len - iRow);
          /** Thêm vào stack */
          skip && obj.Cols.push(col);

          /** Nếu chưa phải dòng cuối */
          if (lenRowspan < len) {
            /** Tăng thứ tự dòng */
            iRow++;
            /** Lấy trong stack thứ tự ô đã xét */
            let i = obj.Childs[iRow] || 0;
            /** Tối đã ô có thể xét */
            let maxColRow = rows[iRow].length;
            /** Đếm colspan */
            let count = 0;

            /** Tìm các config con để đệ quy */
            while (i < maxColRow && count < colspan && iRow <= len) {
              let col = rows[iRow][i++];
              count += col.colspan || 1;
              func(col, iRow, lenRowspan, skip);
            }
          }
        };

        func(col, 0, 0);

        return obj;
      },
      {
        /** Stack lưu index các ô đã xét */
        Childs: [],
        /** Lưu config build */
        Cols: [],
      }
    );

    return rs.Cols;
  }

  /**
   * Tính toán giá trị theo công thức truyền vào
   * @param {any} obj Các giá trị của các node con ({C2: 2, C3: 3})
   * @param {any} formula Công thức tính (C2 + C3)
   * @author: nnnam - 25/4/2022
   */
  calculateByFormula(obj = {}, formula) {
    let result = 0;

    if (formula) {
      let that = this;
      /** Bỏ các khoảng trắng */
      formula = formula.replaceAll(' ', '');

      let sum = ['+', '-'];
      let multi = ['*', '/'];
      /** Mảng tree đệ quy */
      let stack = [
        {
          Key: formula,
          Opera: '+',
          Parent: undefined,
          Grade: 0,
          Id: 0,
          Value: 0,
        },
      ];

      let func = (item, opera) => {
        /** Loại bỏ các dấu () đầu và cuối */
        let mat = item.Key.match(/^\((.*)\)$/);
        mat && (item.Key = mat[1]);

        /** Hash formula theo công thức */
        let tpReg = `[${opera.map((x) => '\\' + x).join('|')}]\(?![^\\(]*\\)\)`;
        let reg = new RegExp(tpReg);
        let regG = new RegExp(tpReg, 'g');

        /** Nếu Hash đc */
        if (item.Key.match(reg)) {
          /** Hash element */
          let ele = item.Key.split(reg);
          /** Hash formula */
          let operas = [...item.Key.match(regG)].map((x) => x[0]);
          /** Mặc định dấu đầu là dấu (+) */
          operas.length < ele.length && operas.unshift('+');

          /** Hash element and save to Stack */
          item.Key.split(reg).forEach((str, i) => {
            let oItem = {
              Key: str,
              Opera: i ? operas[i] : '+',
              Parent: item.Id,
              Grade: item.Grade + 1,
              Id: stack.length,
            };
            stack.push(oItem);
            func(oItem, opera.includes('+') ? multi : sum);
          });
        } else if (item.Key.match(/\+|\-|\*|\//)) {
          func(item, opera.includes('+') ? multi : sum);
        }
      };

      /** Hash phần tử đầu */
      func(stack[0], sum);

      /** Lấy các node lá và gán giá trị */
      let leafs = stack.filter((x) => stack.every((o) => o.Parent != x.Id));
      leafs.forEach((x) => (x.Value = obj[x.Key] || 0));

      // /** Tính giá trị cho các node cha */
      let calculate = (item) => {
        let childs = stack.filter((c) => c.Parent == item.Id);
        if (childs.length) {
          childs.forEach(calculate);

          item.Value = childs.reduce((val, x) => that.calculateOperation(val, x.Value, x.Opera), 0);
        }
      };

      calculate(stack[0]);

      /** Lấy giá trị */
      result = stack[0].Value;
    }

    return result;
  }

  /**
   * Tính toán lại dữ liệu cây
   * @param {Array} data Dữ liệu
   * @param {string} idField Trường ID
   * @param {string} parentField Trường Id cha
   * @param {Array} numberFields Danh sách trường cần cộng
   * @author nnnam - 25/4/2022
   */
  calculateTree(data, key, field, idField, parentField, formulaCol) {
    if (data.length) {
      var that = this;
      /** Mặc định công thức cột rỗng */
      formulaCol = formulaCol || {};

      /** Băm công thức cột */
      let formulaHashCol = Object.keys(formulaCol).reduce(
        (obj, key) => {
          /** @type string */
          let fomuCol = formulaCol[key].replaceAll(' ', '');
          /** Tách cột */
          let spl = fomuCol.split(/\+|\-|\*|\\/);
          /** Lưu lại các cột */
          obj.Hash[key] = spl;
          /** Lưu lại tất cả cột */
          obj.All = obj.All.concat(spl);
          return obj;
        },
        { Hash: {}, All: [field] }
      );

      /** Băm cột */
      let hashCol = formulaHashCol.Hash;
      /** Tất cả các cột */
      let allCols = this.distinct(formulaHashCol.All);
      /** Các cột root */
      let colRoots = Object.keys(hashCol).filter((col) => allCols.every((x) => col != x));

      /** Tìm các node cha */
      let findParents = function (obj, key, hash) {
        let parents = Object.keys(hash).filter((x) => hash[x].some((o) => o == key));
        obj.Item = that.distinct(obj.Item.concat(parents));
        parents.forEach((key) => {
          obj.Child = obj.Child.concat(hash[key]);
          findParents(obj, key, hash);
        });

        obj.Child = that.distinct(obj.Child.filter((child) => obj.Item.every((o) => o != child)));
        return obj;
      };

      /** Các cột root */
      let rootColRs = findParents({ Item: [], Child: [field] }, field, hashCol);
      /** Filter cột root */
      let rootCols = rootColRs.Item.filter((x) => colRoots.some((o) => o == x));
      let rows = [];

      /** Tính toán dòng */
      let calculateRow = (node) => {
        let parents = data.filter((x) => x[idField] == node[parentField]);
        rows = [...rows, ...parents];

        parents.forEach((parent) => {
          let childs = data.filter((x) => x[parentField] == parent[idField]);

          rootColRs.Child.forEach((field) => {
            parent[field] = childs.reduce((sum, child) => sum + parseFloat(child[field] || 0), 0);
          });

          calculateRow(parent);
        });
      };

      /** Tính toán cột */
      let calculateCol = function (col) {
        let childs = hashCol[col];
        let items = childs.filter((x) => rootColRs.Item.some((o) => o == x));
        items.forEach(calculateCol);

        /** For từng dòng */
        rows.forEach((row) => {
          let express = childs.reduce((o, x) => ({ ...o, [x]: row[x] }), {});
          row[col] = that.calculateByFormula(express, formulaCol[col]);
        });
      };

      /** Tính toán dòng */
      data.filter((x) => x[idField] == key).forEach((node) => calculateRow(node));
      /** Tính toán cột */
      rootCols.forEach(calculateCol);
    }
  }

  /**
   * Tính toán dữ liệu bằng công thức
   * @param {Array} data
   * @param {any} keyField
   * @param {any} key
   * @param {any} field
   * @param {any} formulaCol
   * @param {any} formulaField
   * @author nnam - 23/5/2022
   */
  calculateByFormulaColumn(data, keyField, key, field, formulaCol, formulaField = 'Formula') {
    if (data) {
      /** Mặc định công thức cột rỗng */
      formulaCol = formulaCol || {};

      var that = this;

      /** Băm công thức cột */
      let formulaHashCol = Object.keys(formulaCol).reduce(
        (obj, key) => {
          /** @type string */
          let fomuCol = formulaCol[key].replaceAll(' ', '');
          /** Tách cột */
          let spl = fomuCol.split(/\+|\-|\*|\\/);
          /** Lưu lại các cột */
          obj.Hash[key] = spl;
          /** Lưu lại tất cả cột */
          obj.All = obj.All.concat(spl);
          return obj;
        },
        { Hash: {}, All: [field] }
      );

      /** Băm công thức dòng */
      let formulaHashRow = data
        .filter((x) => x[formulaField])
        .reduce(
          (obj, item) => {
            let key = item[keyField];
            /** @type string */
            let formu = item[formulaField].replaceAll(' ', '');
            /** Tách công thức */
            let spl = formu.split(/\+|\-|\*|\\/);
            /** Lưu lại công thức */
            obj.Row[key] = formu;
            /** lưu cột */
            obj.Hash[key] = spl;
            /** Lưu tất cả cột */
            obj.All = obj.All.concat(spl);
            return obj;
          },
          { Row: {}, Hash: {}, All: [key] }
        );

      /** Băm cột */
      let hashCol = formulaHashCol.Hash;
      /** Băm dòng */
      let fomulaRow = formulaHashRow.Row;
      /** Các cột sau khi băm */
      let hashRow = formulaHashRow.Hash;
      /** Tất cả các key */
      let allKeys = that.distinct(formulaHashRow.All);
      /** Tất cả các cột */
      let allCols = that.distinct(formulaHashCol.All);
      /** Các key cha */
      let parentRoots = Object.keys(fomulaRow).filter((key) => allKeys.every((x) => x != key));
      /** Các cột root */
      let colRoots = Object.keys(hashCol).filter((col) => allCols.every((x) => col != x));

      /** Tìm các node cha */
      let findParents = function (obj, key, hash) {
        let parents = Object.keys(hash).filter((x) => hash[x].some((o) => o == key));
        obj.Item = that.distinct(obj.Item.concat(parents));
        parents.forEach((key) => {
          obj.Child = obj.Child.concat(hash[key]);
          findParents(obj, key, hash);
        });

        obj.Child = that.distinct(obj.Child.filter((child) => obj.Item.every((o) => o != child)));
        return obj;
      };

      /** Các cột root */
      let rootColRs = findParents({ Item: [], Child: [field] }, field, hashCol);
      /** Các dòng root */
      let rootRowRs = findParents({ Item: [], Child: [key] }, key, hashRow);
      /** Filter cột root */
      let rootCols = rootColRs.Item.filter((x) => colRoots.some((o) => o == x));
      /** Filter dòng root */
      let rootRows = rootRowRs.Item.filter((x) => parentRoots.some((o) => o == x));
      /** Các dòng chứa công thức */
      let rows = rootRowRs.Child.concat(rootRowRs.Item).reduce(
        (obj, x) => ({ ...obj, [x]: data.filter((o) => o[keyField] == x) }),
        {}
      );
      /** Lấy các dòng công thức tiêu biểu */
      let rowItems = Object.keys(rows).reduce((obj, key) => {
        obj[key] = rows[key] && rows[key][0];
        return obj;
      }, {});

      /** Tính toán dòng */
      let calculateRow = function (key) {
        let childs = hashRow[key];
        let items = childs.filter((x) => rootRowRs.Item.some((o) => o == x));
        items.forEach(calculateRow);

        /** For từng cột */
        rootColRs.Child.forEach((col) => {
          let express = childs.reduce((o, x) => {
            o[x] = rowItems[x][col];
            return o;
          }, {});
          let val = that.calculateByFormula(express, fomulaRow[key]);
          rows[key].forEach((item) => (item[col] = val));
        });
      };

      /** Tính toán cột */
      let calculateCol = function (col) {
        let childs = hashCol[col];
        let items = childs.filter((x) => rootColRs.Item.some((o) => o == x));
        items.forEach(calculateCol);

        /** For từng dòng */
        Object.keys(rowItems).forEach((key) => {
          let express = childs.reduce((o, x) => {
            o[x] = rowItems[key][x];
            return o;
          }, {});
          let val = that.calculateByFormula(express, formulaCol[col]);
          rows[key].forEach((item) => (item[col] = val));
        });
      };

      /** Tính toán dòng */
      rootRows.forEach(calculateRow);
      /** Tính toán cột */
      rootCols.forEach(calculateCol);
    }
  }

  /**
   * Tính toán lại dữ liệu bằng công thức
   * @param {Array} data
   * @param {any} keyField
   * @param {any} formulaCol
   * @param {Array} cols Các cột cần tình mà không có trong công thức
   * @param {any} formulaField
   * @author nnam - 23/5/2022
   */
  refreshByFormulaColumn(data, keyField, formulaCol, cols, formulaField = 'Formula') {
    if (data) {
      let that = this;
      /** Mặc định công thức cột rỗng */
      formulaCol = formulaCol || {};
      cols = cols || [];

      /** Băm công thức cột */
      let formulaHashCol = Object.keys(formulaCol).reduce(
        (obj, key) => {
          /** @type string */
          let fomuCol = formulaCol[key].replaceAll(' ', '');
          /** Tách cột */
          let spl = fomuCol.split(/\+|\-|\*|\\/);
          /** Lưu lại các cột */
          obj.Hash[key] = spl;
          /** Lưu lại tất cả cột */
          obj.All = obj.All.concat(spl);
          return obj;
        },
        { Hash: {}, All: [] }
      );

      /** Băm công thức dòng */
      let formulaHashRow = data
        .filter((x) => x[formulaField])
        .reduce(
          (obj, item) => {
            let key = item[keyField];
            /** @type string */
            let formu = item[formulaField].replaceAll(' ', '');
            /** Tách công thức */
            let spl = formu.split(/\+|\-|\*|\\/);
            /** Lưu lại công thức */
            obj.Row[key] = formu;
            /** lưu cột */
            obj.Hash[key] = spl;
            /** Lưu tất cả cột */
            obj.All = obj.All.concat(spl);
            return obj;
          },
          { Row: {}, Hash: {}, All: [] }
        );

      /** Băm cột */
      let hashCol = formulaHashCol.Hash;
      /** Băm dòng */
      let fomulaRow = formulaHashRow.Row;
      /** Các cột sau khi băm */
      let hashRow = formulaHashRow.Hash;
      /** Tất cả các key */
      let allKeys = this.distinct(formulaHashRow.All);
      /** Tất cả các cột */
      let allCols = this.distinct(formulaHashCol.All);
      /** Các key cha */
      let rootRows = Object.keys(fomulaRow).filter((key) => allKeys.every((x) => x != key));
      /** Các cột root */
      let rootCols = Object.keys(hashCol).filter((col) => allCols.every((x) => col != x));
      let childCols = allCols.concat(cols).filter((x) => !formulaCol.hasOwnProperty(x));

      /** Các dòng chứa công thức */
      let rows = this.distinct(allKeys.concat(rootRows)).reduce(
        (obj, x) => ({ ...obj, [x]: data.filter((o) => o[keyField] == x) }),
        {}
      );
      /** Lấy các dòng công thức tiêu biểu */
      let rowItems = Object.keys(rows).reduce((obj, key) => ({ ...obj, [key]: rows[key] && rows[key][0] }), {});

      /** Tính toán dòng */
      let calculateRow = function (key) {
        let childs = hashRow[key];

        if (childs) {
          childs.forEach(calculateRow);

          /** For từng cột */
          childCols.forEach((col) => {
            let express = childs.reduce((o, x) => {
              o[x] = rowItems[x][col];
              return o;
            }, {});
            let val = that.calculateByFormula(express, fomulaRow[key]);
            rows[key].forEach((item) => (item[col] = val));
          });
        }
      };

      /** Tính toán cột */
      let calculateCol = function (col) {
        let childs = hashCol[col];
        if (childs) {
          childs.forEach(calculateCol);

          /** For từng dòng */
          Object.keys(rowItems).forEach((key) => {
            let express = childs.reduce((o, x) => {
              o[x] = rowItems[key][x];
              return o;
            }, {});
            let val = that.calculateByFormula(express, formulaCol[col]);
            rows[key].forEach((item) => (item[col] = val));
          });
        }
      };

      /** Tính toán dòng */
      rootRows.forEach(calculateRow);
      /** Tính toán cột */
      rootCols.forEach(calculateCol);
    }
  }

  /**
   * Hàm chuẩn hóa tham số
   */
  nomalizeLoadParameter(payload) {
    if (!payload.skip) {
      delete payload.skip;
    }

    if (payload.filter && payload.filter.length > 0) {
      payload.filter = JSON.stringify(payload.filter);
    } else {
      delete payload.filter;
    }

    if (payload.condition && Object.keys(payload.condition).length > 0) {
      payload.condition = JSON.stringify(payload.condition);
    } else {
      delete payload.condition;
    }

    if (payload.columns && payload.columns.length > 0) {
      payload.columns = payload.columns.join(',');
    } else {
      delete payload.columns;
    }
  }

  /**
   * Set từ ngày đến ngày theo kì báo cáo
   * @author nnnam - 20/7/2022
   */
  getDateRange(period, data, flag, type) {
    /**
     * Lấy dữ liệu ngày hiện tại theo ngày HT
     * NXCHIEN 26.07.2022
     */
    let getPostedDate = (flag) => {
      if (flag && flag.isCheck) {
        return new Date(moment(flag.value).format('YYYY-MM-DD'));
      }
      return new Date();
    };

    let dateRange = {};
    if (typeof period !== 'undefined') {
      //Lấy thông tin tuần
      let dateWeek = getPostedDate(flag);

      let day = dateWeek.getDay() === 0 ? 7 : dateWeek.getDay(); // NXCHIEN tính lại ngày đầu tuần
      let first = dateWeek.getDate() - day + 1;
      let last = first + 6;
      let firstWeek = new Date(getPostedDate(flag).setDate(first)).toUTCString();
      let lastWeek = new Date(getPostedDate(flag).setDate(last)).toUTCString();

      //Lấy thông tin tháng
      let dateMonth = getPostedDate(flag);
      let firstMonth = new Date(dateMonth.getFullYear(), dateMonth.getMonth(), 1);

      let lastMonth = new Date(dateMonth.getFullYear(), dateMonth.getMonth() + 1, 0);

      let startCurrentQuater = moment()
        .quarter(moment(getPostedDate(flag)).quarter())
        .startOf('quarter');

      let endCurrentQuater = moment()
        .quarter(moment(getPostedDate(flag)).quarter())
        .endOf('quarter');

      if (!type || type == 'Period') {
        switch (period) {
          case MSConstant.Period.ThisDay:
            dateRange.fromDate = moment(dateWeek).format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.ThisWeek:
            dateRange.fromDate = moment(firstWeek).format('YYYY-MM-DD');
            dateRange.toDate = moment(lastWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FirstWeekToPresent:
            dateRange.fromDate = moment(firstWeek).format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.ThisMonth:
            dateRange.fromDate = moment(firstMonth).format('YYYY-MM-DD');
            dateRange.toDate = moment(lastMonth).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FirstMonthToPresent:
            dateRange.fromDate = moment(firstMonth).format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.ThisQuarter:
            dateRange.fromDate = startCurrentQuater.format('YYYY-MM-DD');
            dateRange.toDate = endCurrentQuater.format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FirstQuarterToPresent:
            dateRange.fromDate = startCurrentQuater.format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.ThisYear:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 0, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 11, 31)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FirstYearToPresent:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 0, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.SixFirstMonth:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 0, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 5, 31)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.SixLastMonth:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 6, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 11, 31)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.January:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 0, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 1, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.February:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 1, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 2, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.March:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 2, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 3, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.April:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 3, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 4, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.May:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 4, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 5, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.June:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 5, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 6, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.July:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 6, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 7, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.August:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 7, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 8, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.September:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 8, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 9, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.October:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 9, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 10, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.November:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 10, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 11, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.December:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 11, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 11, 31)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FiscalI:
            dateRange.fromDate = moment().quarter(1).startOf('quarter').format('YYYY-MM-DD');
            dateRange.toDate = moment().quarter(1).endOf('quarter').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FiscalII:
            dateRange.fromDate = moment().quarter(2).startOf('quarter').format('YYYY-MM-DD');
            dateRange.toDate = moment().quarter(2).endOf('quarter').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FiscalIII:
            dateRange.fromDate = moment().quarter(3).startOf('quarter').format('YYYY-MM-DD');
            dateRange.toDate = moment().quarter(3).endOf('quarter').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FiscalIV:
            dateRange.fromDate = moment().quarter(4).startOf('quarter').format('YYYY-MM-DD');
            dateRange.toDate = moment().quarter(4).endOf('quarter').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.Yesterday:
            dateRange.fromDate = moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD');
            dateRange.toDate = moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.LastWeek:
            dateRange.fromDate = moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD');
            dateRange.toDate = moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.LastMonth:
            dateRange.fromDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
            dateRange.toDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.LastQuarter:
            dateRange.fromDate = moment()
              .quarter(moment().quarter())
              .subtract(1, 'Q')
              .startOf('quarter')
              .format('YYYY-MM-DD');
            dateRange.toDate = moment()
              .quarter(moment().quarter())
              .subtract(1, 'Q')
              .endOf('quarter')
              .format('YYYY-MM-DD');
            break;

          case MSConstant.Period.LastYear:
            dateRange.fromDate = moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD');
            dateRange.toDate = moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.Tomorrow:
            dateRange.fromDate = moment().subtract(-1, 'days').startOf('day').format('YYYY-MM-DD');
            dateRange.toDate = moment().subtract(-1, 'days').endOf('day').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.NextWeek:
            dateRange.fromDate = moment().subtract(-1, 'weeks').startOf('week').format('YYYY-MM-DD');
            dateRange.toDate = moment().subtract(-1, 'weeks').endOf('week').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.NextMonth:
            dateRange.fromDate = moment().subtract(-1, 'months').startOf('month').format('YYYY-MM-DD');
            dateRange.toDate = moment().subtract(-1, 'months').endOf('month').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.NextQuarter:
            dateRange.fromDate = moment()
              .quarter(moment().quarter())
              .subtract(-1, 'Q')
              .startOf('quarter')
              .format('YYYY-MM-DD');
            dateRange.toDate = moment()
              .quarter(moment().quarter())
              .subtract(-1, 'Q')
              .endOf('quarter')
              .format('YYYY-MM-DD');
            break;

          case MSConstant.Period.NextYear:
            dateRange.fromDate = moment().subtract(-1, 'years').startOf('year').format('YYYY-MM-DD');
            dateRange.toDate = moment().subtract(-1, 'years').endOf('year').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.Custom:
            dateRange.fromDate = data?.fromDate;
            dateRange.toDate = data?.toDate;
            break;

          default:
            dateRange.fromDate = null;
            dateRange.toDate = null;
            break;
        }
      } else {
        let year = new Date().getFullYear();
        let month = new Date().getMonth();
        let curMonthQ = month - (month % 3);

        let arr = [
          {
            from: month,
            to: month + 1,
            val: MSConstant.ReportPeriod.ThisMonth,
          },
          /** Tháng */
          { from: 0, to: 1, val: MSConstant.ReportPeriod.January },
          { from: 1, to: 2, val: MSConstant.ReportPeriod.February },
          { from: 2, to: 3, val: MSConstant.ReportPeriod.March },
          { from: 3, to: 4, val: MSConstant.ReportPeriod.April },
          { from: 4, to: 5, val: MSConstant.ReportPeriod.May },
          { from: 5, to: 6, val: MSConstant.ReportPeriod.June },
          { from: 6, to: 7, val: MSConstant.ReportPeriod.July },
          { from: 7, to: 8, val: MSConstant.ReportPeriod.August },
          { from: 8, to: 9, val: MSConstant.ReportPeriod.September },
          { from: 9, to: 10, val: MSConstant.ReportPeriod.October },
          { from: 10, to: 11, val: MSConstant.ReportPeriod.November },
          { from: 11, to: 12, val: MSConstant.ReportPeriod.December },

          {
            from: curMonthQ,
            to: curMonthQ + 3,
            val: MSConstant.ReportPeriod.ThisQuarter,
          },

          /** Quý */
          { from: 0, to: 3, val: MSConstant.ReportPeriod.QuarterI },
          { from: 3, to: 6, val: MSConstant.ReportPeriod.QuarterII },
          { from: 6, to: 9, val: MSConstant.ReportPeriod.QuarterIII },
          { from: 9, to: 12, val: MSConstant.ReportPeriod.QuarterIV },
          /** 6 tháng */
          { from: 0, to: 6, val: MSConstant.ReportPeriod.FirtsHalfYear },
          { from: 6, to: 12, val: MSConstant.ReportPeriod.SecondHalfYear },
          /** Năm */
          { from: 0, to: 12, val: MSConstant.ReportPeriod.Year },
        ];

        var item = arr.find((x) => x.val == period);

        let getDay = (day) => moment(day).format('YYYY-MM-DD');

        if (item) {
          dateRange.fromDate = getDay(new Date(year, item.from, 1));
          dateRange.toDate = getDay(new Date(year, item.to, 0));
        } else {
          dateRange.fromDate = data?.fromDate;
          dateRange.toDate = data?.toDate;
        }
      }
    }

    dateRange.periodText = this.getEnumResource(period.value || MSConstant.Period.Custom, type || 'Period');

    return dateRange;
  }

  /**
   * Lấy kỳ theo Ngày bắt đầu, Ngày kết thúc
   * @author nnnam - 22/7/2022
   */
  getPeriodByDate(fromDate, toDate, flag, type, current) {
    let period = MSConstant.Period.Custom;
    let isReport = type == 'ReportPeriod';

    /**
     * Lấy dữ liệu ngày hiện tại theo ngày HT
     * NXCHIEN 26.07.2022
     */
    let getPostedDate = (flag) => {
      if (flag && flag.isCheck) {
        return new Date(moment(flag.value).format('YYYY-MM-DD'));
      }
      return new Date();
    };

    if (fromDate && toDate) {
      fromDate = new Date(fromDate).getDateOnly();
      toDate = new Date(toDate).getDateOnly();

      let fromDay = fromDate.getDate();
      let fromMonth = fromDate.getMonth() + 1;
      let fromYear = fromDate.getFullYear();

      let nextToDate = new Date(toDate).addDays(1);
      let nextToDay = nextToDate.getDate();
      let nextToMonth = nextToDate.getMonth() + 1;
      let nextToYear = nextToDate.getFullYear();

      let year = getPostedDate(flag).getFullYear();
      let month = getPostedDate(flag).getMonth() + 1;
      let curMonthQ = month - (month % 3);
      let item;

      /** Giá trị map các tháng và giá trị */
      let months = [
        /** Tháng này */
        {
          from: month,
          to: month + 1,
          val: MSConstant.Period.ThisMonth,
          report: MSConstant.ReportPeriod.ThisMonth,
        },
        {
          from: month - 1 || 12,
          to: month,
          val: MSConstant.Period.LastMonth,
          year: month - 1 ? year : year - 1,
        },
        {
          from: month + 1,
          to: month + 2,
          val: MSConstant.Period.NextMonth,
          year: month + 1 < 13 ? year : year + 1,
        },
        /** Tháng */
        {
          from: 1,
          to: 2,
          val: MSConstant.Period.January,
          report: MSConstant.ReportPeriod.January,
        },
        {
          from: 2,
          to: 3,
          val: MSConstant.Period.February,
          report: MSConstant.ReportPeriod.February,
        },
        {
          from: 3,
          to: 4,
          val: MSConstant.Period.March,
          report: MSConstant.ReportPeriod.March,
        },
        {
          from: 4,
          to: 5,
          val: MSConstant.Period.April,
          report: MSConstant.ReportPeriod.April,
        },
        {
          from: 5,
          to: 6,
          val: MSConstant.Period.May,
          report: MSConstant.ReportPeriod.May,
        },
        {
          from: 6,
          to: 7,
          val: MSConstant.Period.June,
          report: MSConstant.ReportPeriod.June,
        },
        {
          from: 7,
          to: 8,
          val: MSConstant.Period.July,
          report: MSConstant.ReportPeriod.July,
        },
        {
          from: 8,
          to: 9,
          val: MSConstant.Period.August,
          report: MSConstant.ReportPeriod.August,
        },
        {
          from: 9,
          to: 10,
          val: MSConstant.Period.September,
          report: MSConstant.ReportPeriod.September,
        },
        {
          from: 10,
          to: 11,
          val: MSConstant.Period.October,
          report: MSConstant.ReportPeriod.October,
        },
        {
          from: 11,
          to: 12,
          val: MSConstant.Period.November,
          report: MSConstant.ReportPeriod.November,
        },
        {
          from: 12,
          to: 13,
          val: MSConstant.Period.December,
          report: MSConstant.ReportPeriod.December,
        },
        /** Quý này */
        {
          from: curMonthQ + 1,
          to: curMonthQ + 4,
          val: MSConstant.Period.ThisQuarter,
          report: MSConstant.ReportPeriod.ThisQuarter,
        },
        {
          from: curMonthQ - 2,
          to: curMonthQ + 1,
          val: MSConstant.Period.LastQuarter,
        },
        {
          from: curMonthQ + 4,
          to: curMonthQ + 7,
          val: MSConstant.Period.NextQuarter,
        },
        /** Quý */
        {
          from: 1,
          to: 4,
          val: MSConstant.Period.FiscalI,
          report: MSConstant.ReportPeriod.QuarterI,
        },
        {
          from: 4,
          to: 7,
          val: MSConstant.Period.FiscalII,
          report: MSConstant.ReportPeriod.QuarterII,
        },
        {
          from: 7,
          to: 10,
          val: MSConstant.Period.FiscalIII,
          report: MSConstant.ReportPeriod.QuarterIII,
        },
        {
          from: 10,
          to: 13,
          val: MSConstant.Period.FiscalIV,
          report: MSConstant.ReportPeriod.QuarterIV,
        },
        /** 6 tháng */
        {
          from: 1,
          to: 7,
          val: MSConstant.Period.SixFirstMonth,
          report: MSConstant.ReportPeriod.FirtsHalfYear,
        },
        {
          from: 7,
          to: 13,
          val: MSConstant.Period.SixLastMonth,
          report: MSConstant.ReportPeriod.SecondHalfYear,
        },
        /** Năm */
        {
          from: 1,
          to: 13,
          val: MSConstant.Period.ThisYear,
          report: MSConstant.ReportPeriod.Year,
        },
        { from: 1, to: 13, val: MSConstant.Period.LastYear, year: year - 1 },
        { from: 1, to: 13, val: MSConstant.Period.NextYear, year: year + 1 },
      ];

      /** Nếu tròn tháng */
      if (fromDay == 1 && nextToDay == 1) {
        var items = months.filter(
          (x) =>
            x.from == fromMonth && x.to == nextToMonth + (nextToYear - fromYear) * 12 && fromYear == (x.year || year)
        );

        item = items.find((x) => (isReport ? x.report : x.val) == current) || items[0];
        item && (period = isReport ? item.report : item.val);
      } else if (!isReport) {
        //Lấy thông tin tuần
        let now = getPostedDate(flag).getDateOnly();
        let day = now.getDay() === 0 ? 7 : now.getDay(); // NXCHIEN tính lại ngày đầu tuần
        let first = now.getDate() - day + 1;

        let firstWeek = new Date(new Date(now).setDate(first));
        let lastWeek = new Date(new Date(now).setDate(first + 6));

        /** Case theo ngày */
        var arr = [
          { from: now, to: now, val: MSConstant.Period.ThisDay },
          {
            from: new Date(now).addDays(-1),
            to: new Date(now).addDays(-1),
            val: MSConstant.Period.Yesterday,
          },
          {
            from: new Date(now).addDays(1),
            to: new Date(now).addDays(1),
            val: MSConstant.Period.Tomorrow,
          },
          {
            from: new Date(firstWeek).addDays(-7),
            to: new Date(lastWeek).addDays(-7),
            val: MSConstant.Period.LastWeek,
          },
          {
            from: new Date(firstWeek).addDays(7),
            to: new Date(lastWeek).addDays(7),
            val: MSConstant.Period.NextWeek,
          },
          { from: firstWeek, to: lastWeek, val: MSConstant.Period.ThisWeek },
          {
            from: firstWeek,
            to: now,
            val: MSConstant.Period.FirstWeekToPresent,
          },
          {
            from: new Date(year, month - 1, 1),
            to: now,
            val: MSConstant.Period.FirstMonthToPresent,
          },
          {
            from: new Date(year, 0, 1),
            to: now,
            val: MSConstant.Period.FirstYearToPresent,
          },
        ];

        var items = arr.filter((x) => moment(x.from).isSame(fromDate) && moment(x.to).isSame(toDate));

        item = items.find((x) => x.val == current) || items[0];
        item && (period = item.val);
      }
    }

    period = period || (isReport ? MSConstant.ReportPeriod.Custom : period);
    let periodText = this.getEnumResource(period, type || 'Period');
    return { period, periodText };
  }

  /**
   * Kiểm tra dữ liệu có phải dạng JSON hay ko
   * HQMINH 25.07.2022
   */
  isJson(str) {
    let bValue = true;
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return bValue;
  }

  /** Sắp xếp data theo tree
   * @author nnnam - 2/11/2020
   * @param {Array} data Dữ liệu sắp xếp
   * @param {string} fieldID Trường sắp xếp, key
   * @param {string} parentID ID của parent
   */
  sortTreeData(data, fieldID = 'id', parentID = 'ParentID') {
    /** Mảng kết quả sau khi sắp xếp theo tree */
    let sort = [];
    data = data.distinctkey(fieldID);
    /** Những node root grade 1 */
    let roots = data.filter((x) => !x[parentID]);

    /**
     * Quy nạp Tìm node con => Thêm vào mảng kết quả
     * @author nnnam - 2/11/2020
     * @param {any} node Node cha
     */
    let initGroup = function (node) {
      /** Danh sách node con */
      let childs = data.filter((x) => node[fieldID] && x[parentID] == node[fieldID]);
      /** Có phải là cha hay không? */
      node._isParent = !!childs.length;
      sort.push(node);
      childs.forEach((child) => {
        child._grade = node._grade + 1;
        initGroup(child);
      });
    };

    roots.forEach((item) => {
      item._grade = 1;
      initGroup(item);
    });

    return sort;
  }

  /**
   * Tìm những node cha trên tree
   * @author: nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} node Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findParentNode(data, node, fieldID = 'id', parentID = 'ParentID', hasCurrent) {
    /** Mảng kết quả trả về chứa danh sách node cha */
    let parents = [];

    /**
     * Đệ quy tìm node cha của node hiện tại
     * @param {any} item Node hiện tại
     * @param {boolean} isCurrent Có Thêm node hiện tại ko?
     */
    let findParent = function (item, isCurrent) {
      /** Node cha */
      let parent = data.find(
        (x) =>
          x[fieldID] &&
          (x[fieldID] && x[fieldID].toLocaleLowerCase()) == (item[parentID] && item[parentID].toLocaleLowerCase())
      );
      /** Nếu có node cha thì đệ quy tìm các node cao hơn */
      parent && findParent(parent);
      /** Nếu không có node hiện tại thì không Thêm */
      !isCurrent && parents.push(item);
    };

    findParent(node, !hasCurrent);
    return parents;
  }

  /**
   * Tìm những node cha trên tree
   * @author: nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} id Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findParentsById(data, id, fieldID = 'id', parentID = 'ParentID', hasCurrent) {
    let node = data.find((x) => x[fieldID] == id);
    return this.findParentNode(data, node, fieldID, parentID, hasCurrent);
  }

  /**
   * Tìm những node con trên tree
   * @author nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} node Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findChildNode(data, node, fieldID, parentID, hasCurrent) {
    /** Mảng kết quả trả về chứa danh sách node con */
    let childs = [];
    fieldID = fieldID || 'id';
    parentID = parentID || 'ParentID';

    /**
     * Đệ quy tìm node con của node hiện tại
     * @param {any} item Node hiện tại
     * @param {boolean} isCurrent Có Thêm node hiện tại ko?
     */
    let findChilds = function (item, isCurrent) {
      /** Node con */
      let childArr = data.filter(
        (x) =>
          x[fieldID] &&
          (x[parentID] && x[parentID].toLocaleLowerCase()) == (item[fieldID] && item[fieldID].toLocaleLowerCase())
      );
      /** Nếu không có node hiện tại thì không Thêm */
      !isCurrent && childs.push(item);
      /** Nếu có node con thì đệ quy tìm các node thấp hơn */
      childArr.forEach((child) => findChilds(child));
    };

    findChilds(node, !hasCurrent);
    return childs;
  }

  /**
   * Tìm những node con trên tree
   * @author nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} node Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findChildsById(data, id, fieldID, parentID, hasCurrent) {
    let node = data.find((x) => x[fieldID] == id);
    return this.findChildNode(data, node, fieldID, parentID, hasCurrent);
  }

  /**
   * Tìm những node con trên tree
   * @author nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} node Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findChildsByField(data, id, fieldID, childField, hasCurrent) {
    let node = data.find((x) => x[fieldID] == id);
    let childs = [];
    fieldID = fieldID || 'id';
    childField = childField || 'childNodes';

    /**
     * Đệ quy tìm node con của node hiện tại
     * @param {any} item Node hiện tại
     * @param {boolean} isCurrent Có Thêm node hiện tại ko?
     */
    let findChilds = function (item, isCurrent) {
      /** Node con */
      let childArr = item[childField] || [];
      /** Nếu không có node hiện tại thì không Thêm */
      !isCurrent && childs.push(item);
      /** Nếu có node con thì đệ quy tìm các node thấp hơn */
      childArr.forEach((child) => findChilds(child));
    };

    node && findChilds(node, !hasCurrent);
    return childs;
  }

  /**
   * Tìm những node con chi tiết nhất (node lá) trên tree
   * @author nnnam - 13/11/2020
   * @param {Array} data Dữ liệu tree
   * @param {object} node Node hiện tại
   * @param {string} fieldID Trường ID key để xác định node
   * @param {string} parentID ID node cha
   * @param {boolean} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findLeafNodes(data, node, fieldID, parentID, hasCurrent) {
    /** Mảng kết quả trả về chứa danh sách node con */
    let childs = MISAUtil.findChildNode(data, node, fieldID, parentID, hasCurrent);
    let result = childs.filter((o) => {
      /** Lấy những node con */
      if (o.hasOwnProperty('_isParent')) {
        return !o._isParent;
      } else {
        return !childs.some((x) => x[parentID] == o[fieldID]);
      }
    });

    return result;
  }

  /**
   * Tìm những node con trên tree
   * @author nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} node Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  checkIsParent(data, par, id, fieldID, parentID, isCurrent) {
    let isParent = !!isCurrent && par == id;
    let node = data.find((x) => x[fieldID] == id);

    /**
     * Đệ quy tìm node cha của node hiện tại
     * @param {any} item Node hiện tại
     */
    let findParent = function (item) {
      /** Node cha */
      let parent = data.find(
        (x) =>
          x[fieldID] &&
          (x[fieldID] && x[fieldID].toLocaleLowerCase()) == (item[parentID] && item[parentID].toLocaleLowerCase())
      );

      if (parent) {
        if (par == parent[fieldID]) {
          isParent = true;
        } else {
          /** Nếu có node cha thì đệ quy tìm các node cao hơn */
          findParent(parent);
        }
      }
    };

    findParent(node);
    return isParent;
  }

  /**
   * Viết hoa chữ đầu tiên
   */
  UpperCaseFirstChar(str) {
    if (!str || typeof str !== 'string') {
      return str;
    }

    if (str.length == 1) {
      return str.toUpperCase();
    }

    return [str.substr(0, 1).toUpperCase(), str.substr(1)].join('');
  }

  /**
   * lấy các gói theo thị trường và id gói
   * @param {Array} data - Danh sách tất cả packages
   * @param {string} national - Mã quốc gia
   * @param {string} packageCode - Mã gói hiện tại
   * @param {boolean} allowDowngrade - Cho phép chọn gói thấp hơn (dùng cho extend)
   */
  getPackageByNationAndPackageCode(data, national, packageCode, allowDowngrade = false, partnerCode = '') {
    //clone data để khử reference
    data = [...data];
    let listDenied = ['CUK.TRL'];
    //Hotfix:
    //Cờ đánh dấu bỏ qua lọc theo quốc gia. do lỗi dữ liệu api tạo request gọi từ BackEnd sang gắn sai national cho domain mỹ thành úc.
    //Muốn sửa triệt để thì cần sửa lại api tạo request
    //TODO: sửa lại api tạo request từ backend
    let skipFilterByNational = false;

    //Nếu là đối tác có giá cả đặc biệt thì lấy các gói có partner_code tương ứng, còn lại thì lấy các gói không có partner_code
    if (partnerCode && CustomPricingPartnerCodes.includes(partnerCode)) {
      data = data.filter((x) => x.PartnerCode?.toLowerCase()?.includes(partnerCode.toLowerCase()) || x.PackID == 1);
    } else {
      data = data.filter((x) => !x.PartnerCode || x.PartnerCode == '');
    }
    // Nếu cho phép downgrade (extend), chỉ loại bỏ CUK.TRL
    if (allowDowngrade) {
      return data?.filter(
        (x) => (skipFilterByNational || x.National == national) && !listDenied.includes(x.ProductPackCode)
      );
    }

    // Logic cũ cho upgrade - chỉ cho phép gói cao hơn
    if (packageCode == 'CUK.STA' || packageCode == 'CUK.STD') {
      listDenied.push('CUK.STT');
    }
    if (packageCode == 'CUK.ADV') {
      listDenied.push('CUK.STT');
      listDenied.push('CUK.STA');
    }
    if (packageCode == 'CUK.PRO') {
      listDenied.push('CUK.STT');
      listDenied.push('CUK.STA');
    }
    if (packageCode == 'CUK.ENT') {
      listDenied.push('CUK.STT');
      listDenied.push('CUK.PRO');
      listDenied.push('CUK.STA');
      listDenied.push('CUK.STD');
    }

    return data?.filter(
      (x) => (skipFilterByNational || x.National == national) && !listDenied.includes(x.ProductPackCode)
    );
  }

  /**
   * Description: Danh sách các loại tiền tệ hỗ trợ
   * Created by: hbviet
   * Created date: 2025-01-21
   */
  getCurrencies() {
    return [
      {
        CurrencyID: 'VND',
        CurrencyName: 'VND',
        SymbolCurrency: 'đ',
        Denomination: '500000; 200000; 100000; 50000; 20000; 10000; 5000; 2000; 1000',
        PositionCurrency: 1,
        EditVersion: 'AAAAAAAARuw=',
      },
      {
        CurrencyID: 'USD',
        CurrencyName: 'Dollar',
        SymbolCurrency: '$',
        Denomination: '100; 50; 20; 10; 5; 1; 0.25; 0.1; 0.05; 0.01',
        PositionCurrency: 1,
        EditVersion: 'AAAAAAAARug=',
      },
      {
        CurrencyID: 'EUR',
        CurrencyName: 'EUR',
        SymbolCurrency: '€',
        Denomination: '50; 20; 10; 5; 2; 1; 0.5; 0.2; 0.1; 0.05; 0.02; 0.01',
        PositionCurrency: 1,
        EditVersion: 'AAAAAAAARoE=',
      },
      {
        CurrencyID: 'LAK',
        CurrencyName: 'LAK',
        SymbolCurrency: '₭',
        Denomination: '50000; 20000; 10000; 5000; 2000; 1000; 500; 100; 50; 10; 5; 1',
        PositionCurrency: 1,
        EditVersion: 'AAAAAAAARqY=',
      },
      {
        CurrencyID: 'CNY',
        CurrencyName: 'CNY',
        SymbolCurrency: '¥',
        Denomination: '100; 50; 20; 10; 5; 1; 0.1; 0.01',
        PositionCurrency: 1,
        EditVersion: 'AAAAAAAARnI=',
      },
      {
        CurrencyID: 'SGD',
        CurrencyName: 'SGD',
        SymbolCurrency: 'S$',
        Denomination: '10000; 1000; 500; 100; 10; 2; 1; 0.5; 0.2; 0.1; 0.05; 0.01',
        PositionCurrency: 1,
        EditVersion: 'AAAAAAAARtQ=',
      },
      {
        CurrencyID: 'THB',
        CurrencyName: 'THB',
        SymbolCurrency: '฿',
        Denomination: '1000; 500; 100; 50; 20; 10; 5; 2; 1; 0.5; 0.25',
        PositionCurrency: 1,
        EditVersion: 'AAAAAAAARt0=',
      },
    ];
  }

  /**
   * Description: Format tiền tệ với ký hiệu và định dạng numeral
   * Created by: hbviet
   * Created date: 2025-01-21
   * @param {number} value - Giá trị tiền cần format
   * @param {string} currencyID - ID của currency (VND, USD, EUR, ...)
   * @returns {string} - Chuỗi tiền tệ đã format
   */
  formatCurrency(value, currencyID) {
    if (!value && value !== 0) return '';

    const currencies = this.getCurrencies();

    // Tìm currency theo ID
    const currency = currencies.find((c) => c.CurrencyID === currencyID);
    const symbolCurrency = currency?.SymbolCurrency || '$';

    return symbolCurrency + numeral(value).format('0,0.00');
  }

  getCurrentNational() {
    let context = store.state['context'];
    let globalcontext = store.state['globalcontext'];
    if (!context || !globalcontext) {
      return '';
    }
    let partners = globalcontext.Partners;
    if (partners && context.User?.PartnerId) {
      let partner = partners.find((x) => x.partner_id == context.User?.PartnerId);
      if (partner && partner.location_id) {
        return partner.location_id;
      }
    }
    return '';
  }
}
export default new CommonFunction();
